<script>
    export let size = 10;
    export let totalPages;
    export let page;
    export let subject;
    export let totalCount;

    function setSize(value) {
        size = value;
        page = 1;
    }

    function setActualPage(value) {
        page = value;
    }

    $: currentPage = +page || 1;
    $: currentSize = +size;
</script>

<div class="flex justify-between h-20 items-center text-lightBlue-600 font-normal text-lg">
    <div class="flex gap-3">
        <button class="{currentSize === 10 ? 'underline font-semibold' : ''}" on:click={() => setSize(10)}>
            10
        </button>
        <button class="{currentSize === 50 ? 'underline font-semibold' : ''}" on:click={() => setSize(50)}>
            50
        </button>
        <button class="{currentSize === 100 ? 'underline font-semibold' : ''}" on:click={() => setSize(100)}>
            100
        </button>
    </div>
    <div class="flex select-none justify-center">
        Totale: {totalCount}
    </div>
    <div class="flex gap-1 md:justify-end">
        <button class="w-5 {currentPage === 1 && 'invisible'}" on:click={() => setActualPage(--currentPage)}>
            <i class="fa fa-chevron-left"></i>
        </button>

        {#if totalPages}
            <button class="outline-none border-0 text-center">
                {currentPage} / {totalPages}
            </button>
        {/if}

        <button class="w-5 {currentPage === totalPages && 'invisible'}"
                disabled="{currentPage === totalPages && totalPages !== 1}"
                on:click={() => setActualPage(++currentPage)}
        >
            <i class="fa fa-chevron-right"></i>
        </button>
    </div>
</div>

<style>
    button {
        border: none;
    }

    button:focus {
        outline: none;
    }
</style>
